import React, { createContext, useContext, useMemo, useState } from 'react';

export const CommissionContext = createContext({});

export function CommissionProvider({ children, savedReview, onReviewCompleted }) {
  const [isOpenModalDepartment, setIsOpenModalDepartment] = useState(false);
  const [isOpenModalStore, setIsOpenModalStore] = useState(false);
  const [isOpenModalReview, setIsOpenModalReview] = useState(false);

  const value = useMemo(
    () => ({
      isOpenModalDepartment,
      setIsOpenModalDepartment,
      isOpenModalStore,
      setIsOpenModalStore,
      isOpenModalReview,
      setIsOpenModalReview,
      savedReview,
      onReviewCompleted,
    }),
    [isOpenModalDepartment, isOpenModalReview, isOpenModalStore, savedReview, onReviewCompleted],
  );

  return <CommissionContext.Provider value={value}>{children}</CommissionContext.Provider>;
}

export const useCommissionContext = () => useContext(CommissionContext);
